export default element => element.style.backgroundColor || element.getAttribute('style')?.includes('--bgcolor') ? 'button' : 'link'